export enum UserCategory {
	ORG = 1,
	FREE = 2,
}
